import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { pipe, switchMap } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isEmpty } from 'lodash-es';
import { IUiError } from '../../core/model';
import { Direction } from '../../enum';
import { BaseState, InputFormData, SearchRequest } from '../../model';
import { InputFormDataService } from '../../services';
import { initialState, withCommonMethods, withCrudMethods } from '../../state';

const initState = initialState<InputFormData>({ field: 'date', direction: Direction.DESC });
export const InputFormDataStore = signalStore(
  withState(initState),
  withCrudMethods(InputFormDataService),
  withCommonMethods()
);

// State
const formData = initialState<InputFormData>({ field: 'date', direction: Direction.DESC });
interface formState {
  inputFormData: Record<string, BaseState<InputFormData>>;
}
const initFormState: formState = { inputFormData: {} };

const formStore = signalStore(
  withState(initFormState),
  withMethods(store => {
    const service = inject(InputFormDataService);
    return {
      search: rxMethod<{ id: string; request: SearchRequest }>(
        pipe(
          tap(data =>
            patchState(store, st => {
              const r = st.inputFormData[data.id];
              return {
                ...st.inputFormData,
                [data.id]: isEmpty(r) ? { ...r, isLoading: true } : { ...formData, isLoading: true },
              };
            })
          ),
          switchMap(data =>
            service.search(data.request).pipe(
              tapResponse({
                next: rsp =>
                  patchState(store, st => {
                    const r = st.inputFormData[data.id];
                    return { ...st.inputFormData, [data.id]: { ...r, page: { ...rsp.page } } };
                  }),
                error: (err: IUiError) =>
                  patchState(store, st => {
                    const r = st.inputFormData[data.id];
                    return { ...st.inputFormData, [data.id]: { ...r, isLoading: false, error: err } };
                  }),
                finalize: () =>
                  patchState(store, st => {
                    const r = st.inputFormData[data.id];
                    return { ...st.inputFormData, [data.id]: { ...r, isLoading: false } };
                  }),
              })
            )
          )
        )
      ),
    };
  })
);
